const table_descritpions = (tab, view) => [{
  key: 'seller_name',
  title: "Seller Name",
  detail: 'The name of the seller.'
}, {
  key: 'period_agg',
  title: "Period",
  detail: 'The period of time the data is aggregated over.'
}, {
  key: 'sales_channel',
  detail: 'The sales channel the data is aggregated over.'
}, {
  key: 'revenue_excl_VAT',
  title: "Revenue (excl. VAT)",
  detail: 'Total income generated, excluding the Value Added Tax (VAT). This includes pending orders waiting for payment finalization.'
}, {
  key: 'evolution_type_button',
  title: 'Revenue evolution switch',
  detail: 'This toggle switches between % values and currency values of evolution'
}, {
  key: 'evolution_sort_button',
  detail: 'Sort by growth'
}, {
  key: 'evolution_sorted_button',
  detail: 'Sorted by growth'
}, {
  key: 'sort_by_revenue',
  detail: 'Sort by revenue'
}, {
  key: 'total_quantity',
  title: "Total Quantity",
  detail: view === 'Advertising' || tab === 'Advertising' ? 'The number of units sold due to advertising efforts' : 'The number of items or products sold.'
}, {
  key: 'units_sold',
  title: "Units Sold",
  detail: view === 'Advertising' || tab === 'Advertising' ? 'The number of units sold due to advertising efforts' : 'The number of items or products sold.'
}, {
  key: 'units_sold_clicks_14_d',
  title: "Units Sold",
  detail: view === 'Advertising' || tab === 'Advertising' ? 'The number of units sold due to advertising efforts' : 'The number of items or products sold.'
}, {
  key: 'days_inventory',
  title: "Days of Inventory",
  detail: 'The estimated number of days remaining before being Out-Of-Stock with the inventory stored at Amazon Warehouses.'
}, {
  key: 'share_sku_sold',
  title: "Share SKU Sold",
  detail: 'The percentage of the total unique products sold out of the entire range of products in stock at Amazon Warehouses.'
}, {
  key: 'share_asin_sold',
  title: "Share ASIN Sold",
  detail: 'The percentage of the total unique products sold out of the entire range of products in stock at Amazon Warehouses.'
}, {
  key: 'lost_revenue_excl_VAT',
  title: "Lost Revenue (excl. VAT)",
  detail: 'The potential income not earned due to out-of-stock items (it excludes non orderable products).'
}, {
  key: 'TACOS',
  title: "Total Advertising Cost of Sale (TACOS)",
  detail: 'TACOS (Total Advertising Cost of Sale)\nYour advertising spend relative to the total revenue generated.'
}, {
  key: 'traffic_by_asin_buy_box_percentage',
  title: "Share Buybox",
  detail: 'The estimated percentage of time your product is featured in the "Buy Box" \
                                            on Amazon\'s product detail page (data checked once a day for Vendor account).'
}, {
  key: 'share_sponsored_sales',
  title: "Share Sponsored Sales",
  detail: 'The percentage of total sales generated through Pay-Per-Click (PPC) advertising.'
}, {
  key: 'sponsor_sales',
  title: "Sponsored Sales",
  detail: 'Sales that have resulted directly from your sponsored ads (14 days post click). \
                                            The conversion could have been made on another product than the click.'
}, {
  key: 'CVR',
  title: "Conversion Rate (CVR)",
  detail: 'CVR (Conversion Rate)\nThe percentage of users who made a purchase after clicking on your ad.'
}, {
  key: 'spend',
  title: "Spend",
  detail: 'The total amount of money spent on advertising.'
}, {
  key: 'ACOS',
  title: "Advertising Cost of Sale (ACOS)",
  detail: '(Advertising Cost of Sale)\nThe ratio of ad spend to sponsored sales.'
}, {
  key: 'cannibalization_cost',
  title: "Cannibalization Cost",
  detail: 'The estimated cost of advertising spend on users that would have purchased your products even without the ads.'
}, {
  key: 'sponsored_net_margin_after_cannibalization_cost',
  title: "Sponsored Net Margin After Cannibalization Cost",
  detail: 'The profit margin from sales that resulted directly from sponsored ads, \
                    after accounting for the costs of those ads and cannibalization.'
}, {
  key: 'sponsored_asin',
  title: "Sponsored ASIN",
  detail: 'The number of products sponsored during the period'
}, {
  key: 'match_type',
  title: "Match Type",
  detail: `
            The parameters that determine how closely the customer's search needs to match your keywords in your Amazon PPC campaign:<br/>
                \t<b>TARGETING_EXPRESSION_PREDEFINED</b>: refers to Amazon's built-in or automatic targeting criteria<br/>
                \t<b>TARGETING_EXPRESSION</b>: manually defined product or category targeting criteria<br/>
                \t<b>EXACT</b>: your ad is shown only when the exact phrase is typed by the customer, with no other words before, after, or in between.<br/>
                \t<b>PHRASE</b>: your ad will appear when users search for your exact keyword phrase in the order<br/>
                            you enter it, but there might be other words before or after that phrase.<br/>
                \t<b>BROAD</b>: your ad will appear when users' search terms contain all the keyword terms or their synonyms,<br/>
                    in any order. For example, if your broad match keyword is “women's hats,” your ad might be displayed<br/>
                    when a user searches for “buy hats for women,” "women's caps," or “ladies' hats.”<br/>
        `
}, {
  key: 'keyword_bid',
  title: "Keyword Bid",
  detail: `The maximum amount you'll pay when a shopper clicks your ad (last update)`
}, {
  key: 'clicks',
  title: "Clicks",
  detail: 'The number of times users have clicked on your ads.'
}, {
  key: 'impressions',
  title: "Impressions",
  detail: 'The number of times your ad was displayed on Amazon or its partner sites. Each appearance of your ad counts as one impression, regardless of whether it was viewed or clicked.'
}, {
  key: 'CTR',
  title: "Click-Through Rate (CTR)",
  detail: `Click-Through Rate (CTR). Calculated as: Clicks / Impressions.
        Indicates how compelling your ad is to shoppers who see it.`
}, {
  key: 'position',
  title: "Position",
  detail: `The organic average rank of your product(s) on the search results on a specific keyword.`
}, {
  key: 'best_position',
  title: "Best Position",
  detail: `The best organic rank of your product(s) on the search results on a specific keyword.`
}, {
  key: 'targeting',
  title: "Targeting",
  detail: 'The PPC targeting strategy (words, asin…) defined in the campaign'
}, {
  key: 'sponsored_sales',
  title: "Sponsored Sales",
  detail: `Sales that have resulted directly from your sponsored ads (14 days post click).
              The conversion could have been made on another product than the click.`
}, {
  key: 'campaign_name',
  title: "Campaign Name",
  detail: 'Campaign Name'
}, {
  key: 'evolution_vs_previous',
  title: "Evolution vs Previous",
  detail: 'The evolution of revenue compared to the previous period'
}, {
  key: 'product_name',
  title: "Product Name",
  detail: 'Product name'
}, {
  key: 'margin_ccy',
  title: "Margin (ccy)",
  detail: "The difference between a product's selling price, production cost, and all direct Amazon fees."
}, {
  key: 'margin_rate',
  title: "Margin Rate",
  detail: 'The ratio of margin to selling price.'
}, {
  key: 'prep_fees',
  title: "Prep Fees",
  detail: 'The cost Amazon charges for preparing an item for shipment.'
}, {
  key: 'fba_fees',
  title: "FBA Fees",
  detail: 'The cost Amazon charges for fulfilling orders (if using FBA).'
}, {
  key: 'referal_fee',
  title: "Referal Fee",
  detail: 'The commission fee that Amazon charges sellers for each item sold.'
}, {
  key: 'tax_est',
  title: "Tax Estimation",
  detail: 'The part of the taxes already included in the price.'
}, {
  key: 'small_and_light',
  title: "Small and Light",
  detail: "Indicates if the sku is enrolled in the Amazon's Small and Light \
              program, an FBA option designed for small and lightweight products \
              offering reduced fulfillment costs to sellers and free shipping to customers."
}, {
  key: 'fulfilmment_program',
  title: "Fulfilment Program",
  detail: 'The method by which products are stored, packed, and shipped, such as Fulfillment by Amazon (FBA).'
}, {
  key: 'COGS',
  title: "Cost of Goods Sold (COGS)",
  detail: '(Cost of Goods Sold)\n\
                The cost to produce the goods, communicated by the brand.'
}, {
  key: 'currency',
  title: "Currency",
  detail: 'The currency used in the country where the product is sold.'
}, {
  key: 'price',
  title: "Price",
  detail: 'The price of the product.'
}, {
  key: 'buybox_winner',
  title: "Buybox Winner",
  detail: `Signifies if you were winning the "Buy Box" on Amazon's product detail page during the last check (once a day)`
}, {
  key: 'country_code',
  title: "Country Code",
  detail: 'The country where the product is sold.'
}, {
  key: 'fees_estimate',
  title: "Fees Estimate",
  detail: 'The total amount of fees Amazon charges for selling the product.'
}, {
  key: 'afn_total_inventory_days',
  title: "AFN Total Inventory Days",
  detail: 'The estimated number of days remaining before being out of stock with the inventory stored at Amazon Warehouses and not sold or already sent to Amazon.'
}, {
  key: 'alert_inventory_level_days',
  title: "Alert Inventory Level Days",
  detail: 'The number of days of inventory below which a future Out Of Stock could be expected if a new replenishment isn’t planned in the 7 coming days.'
}, {
  key: 'total_inventory_minus_threshold',
  title: "Total Inventory Minus Threshold",
  detail: 'The number of days of inventory minus the alert threshold.'
}, {
  key: 'afn_total_quantity',
  title: "AFN Total Quantity",
  detail: 'The number of units in stock at Amazon Warehouses and not already sold to customers or in transition to Amazon Warehouses.'
}, {
  key: 'daily_velocity',
  title: "Daily Velocity",
  detail: 'The average number of units sold daily when the product is available.'
}, {
  key: 'share_total_revenue',
  title: "Share Total Revenue",
  detail: 'The percentage of the total revenue generated by the product out of the total revenue generated by the seller.'
}, {
  key: 'CPC',
  title: "Cost Per Click (CPC)",
  detail: 'The average cost per click.'
}, {
  key: 'targeting_type_CPC',
  title: "Cost Per Click (CPC)",
  detail: 'The average cost per click.'
}, {
  key: 'campaign_budget',
  title: "Daily Budget",
  detail: 'The daily budget of the campaign.'
}, {
  key: 'campaign_group_budget',
  title: "Daily Budget",
  detail: 'The daily budget of the campaign.'
}, {
  key: 'campaign_group_name',
  title: 'Product Group',
  detail: 'The name of the product group.'
}, {
  key: 'ROAS',
  title: "ROAS",
  detail: 'Return on Advertising Spend (ROAS).\nThe ratio of revenue to ad spend.'
}, {
  key: 'organic_CVR',
  title: "Conversion Rate (CVR)",
  detail: 'CVR (Conversion Rate)\nUnits sold divided by page views'
}, {
  key: 'organic_sales',
  title: "Organic Sales",
  detail: 'Organic sales'
}, {
  key: 'rating',
  title: "Rating",
  detail: 'Average rating of your listed product (data checked once a week).'
}, {
  key: 'page_views',
  title: 'Page Views',
  detail: 'Page views of your listed product.'
}, {
  key: 'active_asin_count',
  title: 'Active Asin',
  detail: 'The number of ASINs with an active offer compared to the total number of ASINs listed on Amazon Seller Central.'
}, {
  key: 'return_rate',
  title: 'Return Rate',
  detail: 'The percentage of quantities sold during the period that were returned by customers to Amazon.'
}, {
  key: 'listed_asin_count',
  title: '# active vs listed ASIN',
  detail: "The number of ASINs with an active offer compared to the total number of ASINs listed on Amazon Seller Central."
}, {
  key: 'ratings_total',
  title: "Reviews",
  detail: "Total number of reviews received."
}, {
  key: 'cannibalization_pc',
  title: "Cannibalization Cost",
  detail: 'The estimated cost of advertising spend on users that would have purchased your products even without the ads.'
}, {
  key: "percent_time_in_budget",
  title: "Time in budget",
  detail: "The percentage of time the campaigns remain active without exceeding their allocated budget."
}, {
  key: 'total_ROAS',
  title: "Total ROAS",
  detail: 'Return on Advertising Spend (ROAS).\nThe ratio of revenue to ad spend.'
}, {
  key: "pl_net_revenue",
  title: "Accounting Revenue",
  detail: "Total revenue, excluding taxes, recorded on the expedition date (differs from order date revenue shown in Performance). Represents sellout for Vendors. See details in the Profit and Loss module."
}, {
  key: "pl_contributive_margin",
  title: "Net Margin",
  detail: "Accounting Revenue minus direct and indirect costs. More details available in the Profit and Loss module."
}, {
  key: "pl_net_percentage_revenue",
  title: "% of revenue",
  detail: "Net Margin as a percentage of Accounting Revenue."
}, {
  key: "pl_fba_direct_pc",
  title: "FBA Direct Fees",
  detail: "Variable fulfillment fees for FBA. More details in the Profit and Loss module."
}, {
  key: "pl_amazon_commission_pc",
  title: "Amazon Commission",
  detail: " Referral fees for Sellers or the difference between sellout (minus taxes) and sell-in for Vendors. See details in the Profit and Loss module."
}, {
  key: "pl_fba_indirect_pc",
  title: "FBA Indirect Fees",
  detail: "Fees for inbound, storage, and adjustments. See more details in the Profit and Loss module."
}, {
  key: "pl_refund_pc",
  title: "Refunds & Guarantees",
  detail: "Net costs of refunds and guarantees accounted a the date of the refunds transaction - detail available in the Profit and Loss module."
}, {
  key: "pl_coop_pc",
  title: "Co-op Deductions",
  detail: "Vendor co-op charges as part of Amazon agreements. More details available in the Profit and Loss module."
}, {
  key: "pl_cogs_pc",
  title: "Cost of Goods Sold (COGS)",
  detail: "Costs associated with the Accounting Revenue."
}, {
  key: "pl_other_costs_pc",
  title: "Other Costs",
  detail: "Additional costs not covered in other categories. See details in the Profit and Loss module."
}, {
  key: "pl_advertising_costs",
  title: "Advertising Costs",
  detail: "SP (Sponsored Products) and SB (Sponsored Brands) ad spend, recorded on the date of the expense."
}, {
  key: "avg_unit_price",
  title: "Avg unit price",
  detail: "Revenue excluding tax divided by number of units sold"
}, {
  key: "ad_product",
  title: "Ad Format",
  detail: "Ad Formats"
}, {
  key: "share_of_voice",
  title: "Branded Share of Voice",
  detail: "The percentage of the top 4 Sponsored Product positions occupied by your products on branded keywords. This value is weighted by the 30-day impression volume for each keyword."
}, {
  key: "product_segment",
  title: "Product",
  detail: "Product Segment"
}, {
  key: 'avg_bsr',
  title: "Avg. BSR",
  detail: "The average product’s sales rank within its leaf-level Amazon category. Available only at ASIN x Marketplace level."
}, {
  key: "brand",
  title: "Brand",
  detail: "Brand"
}, {
  key: "market_size",
  title: "Market size (Revenue)",
  detail: "The estimated revenue generated by best-sellers (top 100 variations) in categories that significantly contribute to seller’s revenue."
}, {
  key: "market_units_sold",
  title: "Market size (Units sold)",
  detail: "The estimated number of units sold by best-sellers (top 100 variations) in categories that significantly contribute to seller’s revenue."
}, {
  key: "avg_market_price",
  title: "Average price",
  detail: "The average price of best-selling products in categories that significantly contribute to seller’s revenue."
}, {
  key: "competitor_avg_market_price",
  title: "Average price",
  detail: "The average price of best-selling products in categories that significantly contribute to seller’s revenue."
}, {
  key: "market_price_range",
  title: "Price range",
  detail: "Price range"
}, {
  key: "avg_seller_price",
  title: "Average price",
  detail: "The average price of seller’s products in best-sellers’s selection."
}, {
  key: "seller_share_of_units_sold",
  title: "Market share (Units sold)",
  detail: "The estimated units sold from seller ASINs as a share of total units sold from best-sellers."
}, {
  key: "competitor_seller_share_of_units_sold",
  title: "Market share (Units sold)",
  detail: "The estimated units sold from seller ASINs as a share of total units sold from best-sellers."
}, {
  key: "seller_market_share",
  title: "Market share (Revenue)",
  detail: "The estimated revenue from seller ASINs as a share of total best-sellers revenue."
}, {
  key: "competitor_seller_market_share",
  title: "Market share (Revenue)",
  detail: "The estimated revenue from seller ASINs as a share of total best-sellers revenue."
}, {
  key: "seller_market_share_rank",
  title: "Seller Rank",
  detail: "The seller’s position when all brands are sorted in descending order by market share."
}, {
  key: "competitor_seller_market_share_rank",
  title: "Seller Rank",
  detail: "The seller’s position when all brands are sorted in descending order by market share."
}, {
  key: "relative_marketshare_to_top_competitor",
  title: "Relative share vs. top competitor",
  detail: "The ratio between seller’s estimated revenue and top-performing competitor’s estimated revenue."
}, {
  key: "relative_marketshare_to_preceding_competitor",
  title: "Relative share vs. preceding",
  detail: "The ratio between seller’s estimated revenue and estimated revenue of the competitor ranked immediately above the seller in the market share ranking."
}, {
  key: "best_seller_product_rank",
  title: "Best brand product rank",
  detail: "The seller’s top-performing variation and its sales rank, best ASIN, country."
}, {
  key: "avg_seller_rating",
  title: "Ratings",
  detail: "Ratings"
}, {
  key: "avg_seller_rating_per_product",
  title: "Average reviews",
  detail: "Average number of reviews across all products listed under the seller."
}, {
  key: "brand_revenue",
  title: "Est. revenue",
  detail: "The estimated revenue generated by best-sellers (top 100 variations)."
}, {
  key: "brand_units_sold",
  title: "Est. units sold",
  detail: "The estimated number of units sold by best-sellers (top 100 variations)."
}, {
  key: 'category',
  title: "Category",
  detail: 'Amazon leaf-level category containing seller-listed products.'
}, {
  key: 'category_revenue_share',
  title: "Category Revenue Share",
  detail: 'Category Revenue Share'
}, {
  key: 'search_query_volume',
  title: "Searches volume",
  detail: 'Total number of searches performed by visitors on Amazon marketplace on a pool of keywords selected by Amazon as the most relevant to your products (top 100 keywords per ASIN x marketplace x week)'
}, {
  key: 'impression_share',
  title: "Brand Impressions share",
  detail: 'Percentage of total impressions (ads + organic) seller received from analyzed searches. Includes impressions on viewed result pages, even if not visible on screen.'
}, {
  key: 'impression_count',
  title: "Brand Impressions",
  detail: "Total times seller's ASINs appeared (ads + organic) in search results from analyzed queries, even if not visible on screen."
}, {
  key: 'click_share',
  title: "Brand Click share",
  detail: "Percentage of total clicks from analyzed searches on seller's ASINs (ads + organic)."
}, {
  key: 'click_count',
  title: "Brand clicks",
  detail: "Total clicks the seller's ASINs received (ads + organic) from analyzed search queries."
}, {
  key: 'purchase_share',
  title: "Brand Purchases share",
  detail: 'Share of orders from analyzed searches including at least one seller product'
}, {
  key: 'purchase_count',
  title: "Brand purchases",
  detail: 'Total number of orders originating from the analyzed searches including at least one seller product.'
}, {
  key: 'ordered_revenue_amount',
  title: "Ordered Revenue",
  detail: 'Revenue generated by a customer order with adjustments made for prior sales, such as returns or cancellations.'
}, {
  key: 'shipped_revenue_amount',
  title: "Shipped Revenue",
  detail: 'Revenue generated at the time of shipment. Shipped Revenue = Price × Shipped Units.'
}, {
  key: 'shipped_cogs_amount',
  title: "Shipped COGS(PCOGS)",
  detail: 'Product Cost of Goods Sold — the price Amazon paid to the vendor for item procurement.'
}, {
  key: 'net_ppm_amount',
  title: "Net PPM",
  detail: 'Net Pure Product Margin — Amazon’s margin after taking into account CCOGS and sales discounts. Net PPM = (Shipped Revenue – Shipped COGS + CCOGS – Sales Discount) / Shipped Revenue.'
}, {
  key: 'net_ppm_pc',
  title: "Net PPM",
  detail: 'Net Pure Product Margin — Amazon’s margin after taking into account CCOGS and sales discounts. Net PPM = (Shipped Revenue – Shipped COGS + CCOGS – Sales Discount) / Shipped Revenue.'
}, {
  key: 'vendor_return_rate',
  title: "Customer Returns",
  detail: 'Number of units returned by customers, applied to ordered revenue based on the original sale date.'
}, {
  key: 'net_received_inventory_cost_amount_eur',
  title: "Net Received Units",
  detail: 'Net units received by Amazon.'
}, {
  key: 'search_query',
  title: 'Keyword',
  detail: 'Keyword'
}, {
  key: 'conversion_rate',
  title: 'CVR',
  detail: 'Conversion Rate (CVR). Calculated as Purchases / Clicks'
}, {
  key: 'brand_ctr',
  title: 'CTR',
  detail: 'Click-Through Rate (CTR). Calculated as Clicks / Impressions.'
}, {
  key: 'search_revenue_share',
  title: 'Search share of revenue',
  detail: 'Share of total revenue generated by purchases that started with a customer search and were completed within 24 hours.'
}, {
  key: 'seller_notoriety',
  title: 'Brand searches',
  detail: 'Total number of searches including your brand name performed by visitors on Amazon marketplace'
}, {
  key: 'dsp_roas_vs_target',
  title: 'ROAS vs target',
  detail: 'Return on Ad Spend (ROAS) generated by featured products sales, compared to the target ROAS weighted by the order-level budget.'
}, {
  key: 'dsp_assisted_sales',
  title: 'Assisted sales',
  detail: 'Revenue generated from advertised products following a DSP ad exposure or interaction (14-day post-exposure attribution window)'
}, {
  key: 'order_id',
  title: 'Order',
  detail: 'Order'
}, {
  key: 'line_item_id',
  title: 'Line item',
  detail: 'Line item'
}, {
  key: 'dsp_percent_assisted_sales',
  title: '% of DSP assisted sales',
  detail: 'Percentage of revenue generated from shoppers who were exposed to DSP ads prior to making a purchase (main corresponding to advertised products - halo corresponding to other products of the brand)'
}, {
  key: 'dsp_ecpm',
  title: 'eCPM',
  detail: 'Effective Cost per Thousand Impressions. Total spend divided by total impressions (in thousands), reflecting the actual cost efficiency of media delivery.'
}, {
  key: 'dsp_new_customers',
  title: 'New Customers',
  detail: 'Number of customers who purchased advertised products (single purchase or SNS) following a DSP ad exposure, with no purchase in the last 365 days (New to Brand).'
}, {
  key: 'dsp_cpa_conversion',
  title: 'CPA',
  detail: 'Cost per acquisition for New to Brand customers (no purchase in the last 365 days), calculated as total spend divided by the number of new customers.'
}, {
  key: 'dsp_cpa_consideration',
  title: 'CPA',
  detail: 'Cost per consideration signal, calculated as total spend divided by the number of consideration events (Detail Page Views and Add to Cart).'
}, {
  key: 'dsp_cpa_loyalty',
  title: 'CPA',
  detail: 'Cost per repurchase, calculated as total spend divided by the number of purchases made by existing customers.'
}, {
  key: 'dsp_spend',
  title: 'Spend',
  detail: 'Total media budget invested in Amazon DSP campaigns over the selected period.'
}, {
  key: 'dsp_units_sold',
  title: 'Units sold',
  detail: 'Number of product units purchased following a DSP ad exposure (14-day post-exposure attribution window).'
}, {
  key: 'dsp_atc_clicks',
  title: 'ATC Clicks - Add to cart clicks ',
  detail: 'Number of times shoppers added products from a brand to their cart, attributed to an ad click.'
}, {
  key: 'dsp_atc_views',
  title: 'ATC Views - Add to cart views',
  detail: 'Number of times shoppers added products from the brand to their cart, attributed to an ad view.'
}, {
  key: 'dsp_dpv_clicks',
  title: 'DPV Clicks - Detail Page view clicks',
  detail: 'Number of detail page views occurring within 14 days of an ad click.'
}, {
  key: 'dsp_dpv_views',
  title: 'DPV Views - Detail Page view views',
  detail: 'Number of detail page views for promoted products, attributed to an ad view.'
}, {
  key: 'dsp_brand_searches',
  title: 'Brand Searches',
  detail: 'Number of searches for the brand name on Amazon following a DSP ad exposure.'
}, {
  key: 'dsp_impressions',
  title: 'Impressions',
  detail: 'Number of delivered impressions, split between viewable impressions (meeting the MRC viewability standard at least 50% of the ad in view for a minimum of 1 second for display, 2 seconds for video + user identified) and non-viewable (mix of impressions that did not meet the MRC viewability standard and impressions delivered to unidentified people)'
}, {
  key: 'dsp_vtr',
  title: 'VTR - View-through rate (display only)',
  detail: 'Share of viewable impressions'
}, {
  key: 'dsp_delivery_rate',
  title: 'Delivery Rate',
  detail: 'Share of the planned budget that was actually spent over the selected period.'
}, {
  key: 'dsp_percent_ntb_cust',
  title: '% NTB cust.',
  detail: 'Share of total purchasers who are New to Brand (no purchase of the brand in the last 365 days).'
}, {
  key: 'dsp_cvr',
  title: 'CVR',
  detail: 'Number of purchases (New to Brand + Existing customers) divided by the number of detail page view clicks'
}, {
  key: 'dsp_post_click_purch',
  title: 'Post Click Purch',
  detail: 'Number of purchases of advertised products following a direct click on a DSP ad compared to total purchases on the same scope.'
}, {
  key: 'dsp_halo',
  title: 'Halo',
  detail: 'Share of total DSP-attributed revenue generated by non-advertised products from the same brand.'
}, {
  key: 'dsp_consideration_signals',
  title: 'Consideration Signals',
  detail: 'High-intent engagement actions (Detail Page Views and Add to Cart events) recorded following a DSP ad exposure. They trigger the move from consideration to conversion step.'
}, {
  key: 'dsp_dpvr_vs_target',
  title: 'DPVR vs Target',
  detail: 'Detail Page View Rate compared to the target DPVR weighted by the order-level budget. Calculated as the number of DPVs (clicks + views) divided by viewable impressions.'
}, {
  key: 'dsp_dpv',
  title: 'DPV - Detail Page view',
  detail: 'Number of detail page views for promoted products (attributed to an ad view or within 14 days of an ad click)'
}, {
  key: 'dsp_atc',
  title: 'ATC - Add to cart',
  detail: 'Number of times shoppers added products from the brand to their cart'
}, {
  key: 'dsp_percent_dpv_click',
  title: '% DPV Click',
  detail: 'Share of DPVs attributed to clicks vs. total DPVs (clicks + views), indicating the relative contribution of click-through traffic to product page visits.'
}, {
  key: 'dsp_repurchases',
  title: 'Repurchases',
  detail: 'Number of purchases made by existing customers (at least one purchase of the brand in the last 365 days) following a DSP ad exposure (including both simple purchases and new SnS)'
}, {
  key: 'dsp_percent_existing_cust',
  title: '% Existing cust',
  detail: 'Share of total purchasers who are existing customers (at least one purchase of the brand in the last 365 days prior to DSP assisted purchase).'
}, {
  key: 'dsp_overview_budget',
  title: 'Budget',
  detail: 'Total media budget allocated to campaigns within the funnel stage.'
}, {
  key: 'dsp_overview_spend',
  title: 'Spend',
  detail: 'Total media budget invested in Amazon DSP campaigns over the selected period.'
}, {
  key: 'dsp_overview_delivery_rate',
  title: 'Delivery rate',
  detail: 'Share of the planned budget that was actually spent over the selected period.'
}, {
  key: 'dsp_overview_objective',
  title: 'Objective',
  detail: 'Primary business outcome the campaign aims to maximize.'
}, {
  key: 'dsp_overview_cpa',
  title: 'CPA',
  detail: 'Average cost to generate one objective action (spend / repurchases|new customers|consideration signals)'
}, {
  key: 'dsp_overview_optimization_kpi',
  title: 'Optimization KPI',
  detail: 'Performance metric used by Amazon DSP bidding algorithms to optimize delivery and ad placement selection toward the campaign objective.'
}, {
  key: 'dsp_overview_assisted_sales',
  title: 'Assisted sales',
  detail: 'Revenue generated from advertised products following a DSP ad exposure or interaction (14-day post-exposure attribution window)'
}, {
  key: 'dsp_overview_assisted_units_sold',
  title: 'Assisted units sold',
  detail: 'Number of product units purchased following a DSP ad exposure (14-day post-exposure attribution window).'
}, {
  key: 'customer_period_agg',
  title: "Period",
  detail: 'The period of time the data is aggregated over.'
}, {
  key: 'active_customers_12m',
  title: "Active Customers (12M)",
  detail: 'Number of unique customers who made at least one purchase in the last 12 months.'
}, {
  key: 'monthly_net_acquisition',
  title: "Net Acquisition",
  detail: 'Net number of new active customers (trailing 12 months) acquired during the month.'
}, {
  key: 'new_customers_month',
  title: "New Customers (month)",
  detail: 'Number of customers whose first-ever purchase occurred during the selected month.'
}, {
  key: 'pct_new_customers',
  title: "Acquisition rate",
  detail: 'Share of monthly new customers relative to the 12M active customer base. Formula: New Customers (month) / Active Customers (12M).'
}, {
  key: 'cac',
  title: "CAC",
  detail: 'Amazon customer acquisition cost = Amazon PPC spend ÷ number of new customers over the period. Measures the average ad cost to acquire one new customer.'
}, {
  key: 'churned_customers_12m_month',
  title: "Churned Customers (12M)",
  detail: 'Customers active 12 months ago with no purchase in the last 12 months.'
}, {
  key: 'pct_churned_customers_12m',
  title: "Churn rate",
  detail: 'Churn rate relative to the 12M active customer base. Formula: Churned Customers (12M) / Active Customers (12M).'
}, {
  key: 'reactivated_customers_month',
  title: "Reactivated Customers (month)",
  detail: 'Returning customers active this month with no purchase in the prior 12 months.'
}, {
  key: 'avg_revenue_per_active_customer_12m',
  title: "ARPA (Avg Revenue Per Active Customer, 12M)",
  detail: 'Formula: Revenue (12M) / Active Customers (12M).'
}, {
  key: 'avg_aov_12m',
  title: "AOV (Average Order Value, 12M)",
  detail: 'Formula: Revenue (12M) / Total Purchases (12M).'
}, {
  key: 'avg_purchase_per_active_customer_12m',
  title: "#purchases 12m (Avg Purchases Per Active Customer, 12M)",
  detail: 'Formula: Total Purchases (12M) / Active Customers (12M).'
}, {
  key: 'median_time_between_purchases_days_12m',
  title: "Median Time Between Purchases (days, 12M)",
  detail: 'Median number of days between two consecutive purchases for customers with 2+ orders in the last 12 months. (Available for Seller accounts only)'
}, {
  key: 'pct_active_customers_12m_with_2plus_purchases',
  title: ">2 purchases (% Active 2+ Purchases, 12M)",
  detail: 'Share of active customers who placed at least two orders in the last 12 months. Formula: Active Customers 2+ Purchases (12M) / Active Customers (12M).'
}, {
  key: 'pct_revenue_subscribe_and_save_month',
  title: "% Subscribe & Save Revenue (month)",
  detail: 'Share of monthly revenue generated through Subscribe & Save orders. Formula: SnS Revenue (month) / Total Revenue (month). (Available for Seller accounts only)'
}, {
  key: 'cohort_period',
  title: "Period",
  detail: 'The period of time the data is aggregated over.'
}, {
  key: 'ltv_new_customers',
  title: "New Customers",
  detail: ''
}, {
  key: 'ltv_cac',
  title: "CAC",
  detail: ''
}, {
  key: 'ltv_retention_rate_monthly',
  title: "R-%",
  detail: ''
}, {
  key: 'ltv_first_order',
  title: "First Order",
  detail: ''
}, {
  key: 'ltv_offset_00',
  title: "0",
  detail: ''
}, {
  key: 'ltv_offset_01',
  title: "1",
  detail: ''
}, {
  key: 'ltv_offset_02',
  title: "2",
  detail: ''
}, {
  key: 'ltv_offset_03',
  title: "3",
  detail: ''
}, {
  key: 'ltv_offset_04',
  title: "4",
  detail: ''
}, {
  key: 'ltv_offset_05',
  title: "5",
  detail: ''
}, {
  key: 'ltv_offset_06',
  title: "6",
  detail: ''
}, {
  key: 'ltv_offset_07',
  title: "7",
  detail: ''
}, {
  key: 'ltv_offset_08',
  title: "8",
  detail: ''
}, {
  key: 'ltv_offset_09',
  title: "9",
  detail: ''
}, {
  key: 'ltv_offset_10',
  title: "10",
  detail: ''
}, {
  key: 'ltv_offset_11',
  title: "11",
  detail: ''
}, {
  key: 'ltv_offset_12',
  title: "12",
  detail: ''
}, {
  key: 'purchases_share',
  title: "Brand Purchase Share",
  detail: 'Share of orders from analyzed searches including at least one seller product.'
}, {
  key: 'top_product',
  title: "Top Product",
  detail: "The product most frequently appearing in organic results for the selected scope — either yours or a competitor's."
}, {
  key: 'sf_share_of_voice',
  title: ["Share of Voice - Top 1", "Share of Voice - Top 3", "Share of Voice - Top 10"],
  detail: ['The share of time your products appear in the top 1 organic results for the selected scope.', 'The share of time your products appear in the top 3 organic results for the selected scope.', 'The share of time your products appear in the top 10 organic results for the selected scope.'],
  sublabels: ['Top 1', 'Top 3', 'Top 10']
}, {
  key: 'sf_best_position',
  title: "Best Position",
  detail: 'The highest organic ranking reached by your products over the period, along with the product that achieved it.'
}, {
  key: "sov_sponsored",
  title: "SOV Sponsored",
  detail: 'The share of time your products appear in the sponsored placements at the top of search results pages.'
}, {
  key: "no_impressions_per_search",
  title: "#Impressions per Search",
  detail: 'The average number of sponsored impressions (Products & Brand) generated by your brand per search on the selected scope.'
}, {
  key: "sf_click_share",
  title: "Click Distribution",
  detail: 'The breakdown of clicks of the selected scope, split between Sponsored Products, Sponsored Brands, and organic.'
}, {
  key: "estimated_opportunity",
  title: "Estimated Opportunity",
  detail: 'The estimated revenue you could gain by closing the gap with a realistic purchase share target. On branded keywords, the target is 100%. On non-branded keywords, it\'s set to the higher of +20% above your current share or your best historical performance (P80 over 12 months).'
}, {
  key: "ltv_product_name",
  title: "Product",
  detail: 'Entry-point product : the first item purchased by customers in the last 12 months cohort'
}, {
  key: "ltv_per_asin_new_customers",
  title: "Entry Customers",
  detail: 'Number of unique customers whose first purchase in the catalog was this product, during the last 12 months.'
}, {
  key: "ltv_per_asin_multiplier",
  title: "LTV multiplier",
  detail: 'Ratio of Average LTV to the average first purchase value for this product (LTV ÷ First Purchase Value). Shows how much additional value, on average, a customer generates after their first purchase.'
}, {
  key: "ltv_per_asin_breakdown",
  title: "LTV Breakdown",
  detail: 'Average total value generated per customer who entered the catalog through this product, including their first purchase plus all subsequent repeat and cross-sell purchases within the period'
}];
export default table_descritpions;